<template>
  <footer>
    <div class="router-content">
      <router-link class="router-link" target="_blank" to="/terms">利用規約</router-link>
      <router-link class="router-link" target="_blank" to="/privacy">プライバシーポリシー</router-link>
      <router-link class="router-link" target="_blank" to="/specific_business">特定商取引法に基づく表示</router-link>
      <router-link v-if="checkDevice=='pc'" class="router-link" target="_blank" to="/based">資金決済法に基づく表示</router-link>
      <router-link v-if="checkDevice=='pc'" class="router-link" target="_blank" to="/fankit/guidelines">二次創作ガイドライン</router-link>
      <div v-if="checkDevice=='mobile'" class="router-content__bottom">
        <router-link class="router-link" target="_blank" to="/based">資金決済法に基づく表示</router-link>
        <router-link class="router-link" target="_blank" to="/fankit/guidelines">二次創作ガイドライン</router-link>
      </div>
    </div>
    <div class="logo-content">
      <div class="logo-wrap">
        <img class="logo-yostar" src="../assets/images/yostarBottom.png" alt />
      </div>
      <!-- <div class="copyright-wrap">
                <img class="copyright" src="../assets/images/copyright.png" alt="">
      </div>-->
    </div>
  </footer>
</template>

<script>
export default {
  name: "",

  components: {},
  data: () => ({}),
  created() { },
  mounted() { },
  watch: {},
  computed: {
    checkDevice() {
      return this.$utils.checkDevice();
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
footer {
  width: 100%;
  height: auto !important;
  background: #fff url("../assets/images/textrue_bg.png");
  margin-top: -1px;
  position: relative;
  z-index: 998;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: pxTorem(40px) 0 pxTorem(70px);

  .router-content {
    .router-link {
      font-family: "Noto Sans JP", sans-serif;
      font-weight: 700;
      color: #000;
      font-size: pxTorem(22px);

      &:not(:last-of-type) {
        border-right: 3px solid #000;
        padding-right: pxTorem(28px);
        margin-right: pxTorem(28px);
      }
    }
    &__bottom {
      display: inline;
    }
  }

  .logo-content {
    width: pxTorem(666px);
    margin-top: pxTorem(64px);

    .logo-wrap {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .logo-yostar {
        width: pxTorem(666px);
      }
    }
    .copyright-wrap {
      font-size: pxTorem(18px);
      margin-top: pxTorem(24px);
      display: flex;
      font-family: "Noto Sans JP", sans-serif;
      font-weight: 700;
      .copyright {
        width: pxTorem(387px);
      }
    }
  }
}

@media screen and (max-width: 600px) {
  footer {
    width: 100%;
    height: auto !important;
    background: #fff url("../assets/images/textrue_bg.png");
    margin-top: -1px;
    position: relative;
    z-index: 998;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: MpxTorem(40px) 0 MpxTorem(70px);

    .router-content {
      text-align: center;
      &__bottom {
        display: block;
      }
      .router-link {
        font-family: "Noto Sans JP", sans-serif;
        font-weight: 700;
        color: #000;
        font-size: MpxTorem(24px);

        &:not(:last-of-type) {
          border-right: 2px solid #000;
          padding-right: pxTorem(28px);
          margin-right: pxTorem(28px);
        }
      }
    }

    .logo-content {
      width: MpxTorem(500px);
      margin-top: MpxTorem(75px);

      .logo-wrap {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;

        .logo-yostar {
          width: MpxTorem(500px);
        }
      }
      .copyright-wrap {
        font-size: 12px;
        margin-top: MpxTorem(24px);
        display: flex;
        font-family: "Noto Sans JP", sans-serif;
        font-weight: 700;
        .copyright {
          width: MpxTorem(347px);
        }
      }
    }
  }
}
@media (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
  footer {
    width: 100%;
    height: auto !important;
    background: #fff url("../assets/images/textrue_bg.png");
    margin-top: -1px;
    position: relative;
    z-index: 998;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: pxTorem(40px) 0 pxTorem(70px);

    .router-content {
      .router-link {
        font-family: "Noto Sans JP", sans-serif;
        font-weight: 700;
        color: #000;
        font-size: pxTorem(24px);

        &:not(:last-of-type) {
          border-right: 3px solid #000;
          padding-right: pxTorem(28px);
          margin-right: pxTorem(28px);
        }
      }
    }

    .logo-content {
      width: pxTorem(810px);
      margin-top: pxTorem(64px);

      .logo-wrap {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .logo-nat-games {
          width: pxTorem(243px);
        }
        .logo-yostar {
          width: pxTorem(387px);
        }
      }
      .copyright-wrap {
        font-size: pxTorem(18px);
        margin-top: pxTorem(24px);
        display: flex;
        font-family: "Noto Sans JP", sans-serif;
        font-weight: 700;
        .copyright {
          width: pxTorem(800px);
        }
      }
    }
  }
}
@media (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  footer {
    width: 100%;
    height: auto !important;
    background: #fff url("../assets/images/textrue_bg.png");
    margin-top: -1px;
    position: relative;
    z-index: 998;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: MpxTorem(40px) 0 MpxTorem(70px);

    .router-content {
      .router-link {
        font-family: "Noto Sans JP", sans-serif;
        font-weight: 700;
        color: #000;
        font-size: MpxTorem(28px);

        &:not(:last-of-type) {
          border-right: 2px solid #000;
          padding-right: pxTorem(34px);
          margin-right: pxTorem(34px);
        }
      }
    }

    .logo-content {
      width: MpxTorem(720px);
      margin-top: MpxTorem(75px);

      .logo-wrap {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding: 0 MpxTorem(24px);

        .logo-nat-games {
          width: MpxTorem(225px);
        }
        .logo-yostar {
          width: MpxTorem(352px);
        }
      }
      .copyright-wrap {
        max-width: pxTorem(347px);
        font-size: 12px;
        margin-top: MpxTorem(24px);
        display: flex;
        font-family: "Noto Sans JP", sans-serif;
        font-weight: 700;
        .copyright {
          width: MpxTorem(720px);
        }
      }
    }
  }
}
</style>
